import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_STAGING_BACKEND_BASE_URI
});

export default instance;